import { render, staticRenderFns } from "./ProductEditVariantText.vue?vue&type=template&id=796aafc0&scoped=true&"
import script from "./ProductEditVariantText.vue?vue&type=script&lang=js&"
export * from "./ProductEditVariantText.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditVariantText.vue?vue&type=style&index=0&id=796aafc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796aafc0",
  null
  
)

export default component.exports